import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { MixedType } from './MixedType';
export var BooleanType = /*#__PURE__*/function (_MixedType) {
  _inheritsLoose(BooleanType, _MixedType);

  function BooleanType(errorMessage) {
    var _this;

    _this = _MixedType.call(this, 'boolean') || this;

    _MixedType.prototype.pushRule.call(_assertThisInitialized(_this), {
      onValid: function onValid(v) {
        return typeof v === 'boolean';
      },
      errorMessage: errorMessage || _this.locale.type
    });

    return _this;
  }

  return BooleanType;
}(MixedType);
export default function getBooleanType(errorMessage) {
  return new BooleanType(errorMessage);
}